import * as React from 'react';
import { Button, Icon, Table, Upload, message } from 'antd';
import { UploadChangeParam } from 'antd/lib/upload/interface';
import { EventSubscription } from 'fbemitter';

import EditorDispatcher from '../../dispatchers/EditorDispatcher';
import EditorStore from '../../stores/EditorStore';
import { removeListener } from '../../utils';

interface EditorTabData {
  editors: Editor[];
}

export class EditorTab extends React.Component<{}, EditorTabData> {
  private editorListener: EventSubscription | null = null;

  constructor(props: {}) {
    super(props);

    this.state = {
      editors: EditorStore.getEditors(),
    };
  }

  render() {
    return (
      <span>
        <div className="center buffer">
          <Upload
            accept=".csv"
            action="/api/upload_editor_csv"
            onChange={this.handleUploadChange}
            showUploadList={false}
            withCredentials={true}
          >
            <Button>
              <Icon type="upload" /> Upload and Overwrite Editors
            </Button>
          </Upload>
        </div>
        <Table
          dataSource={this.state.editors}
          rowKey="email"
          size="small"
          pagination={false}
          columns={[
            {
              title: 'Name',
              dataIndex: 'name',
              key: 'name',
            },
            {
              title: 'Email',
              dataIndex: 'email',
              key: 'email',
            },
            {
              title: 'Volume',
              dataIndex: 'volume',
              key: 'volume',
              sorter: (a: Editor, b: Editor) => a.volume - b.volume,
            },
            {
              title: 'Role',
              dataIndex: 'role',
              key: 'role',
            },
          ]}
        />
      </span>
    );
  }

  componentDidMount() {
    this.editorListener = EditorStore.addListener(() => {
      this.setState({
        editors: EditorStore.getEditors(),
      });
    });
  }

  componentWillUnmount() {
    removeListener(this.editorListener);
  }

  private handleUploadChange(params: UploadChangeParam) {
    if (params.file.status === 'done') {
      message.success('CSV file uploaded successfully;');
      EditorDispatcher.handleUpdateEditors(params.file.response);
    } else if (params.file.status === 'error') {
      message.error('CSV file upload failed.');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminTabs/EditorTab.tsx